// extracted by mini-css-extract-plugin
export default {"form":"ContactForm_form__dhl+T","label":"ContactForm_label__-cVXI","text":"ContactForm_text__kqq6l","input":"ContactForm_input__Bl93P","button":"ContactForm_button__eSwX9"};